export default __webpack_public_path__ + "static/media/planken-wambuis.3bfcce0a.png";